import { render, staticRenderFns } from "./grayscaleVersion.vue?vue&type=template&id=2e3074e8&scoped=true"
import script from "./grayscaleVersion.vue?vue&type=script&lang=js"
export * from "./grayscaleVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3074e8",
  null
  
)

export default component.exports